// extracted by mini-css-extract-plugin
export default {"ChartLegend":"ChartLegend_ChartLegend__TMiym","amount":"ChartLegend_amount__B9U2Z","colorTag":"ChartLegend_colorTag__U2XlU","label":"ChartLegend_label__bchaM"};